<template>
	<div class="content profile-content" >
		<ProfileNavbar :title="$t('sidebar.notifications')"></ProfileNavbar>
		<router-link
			to="/notification"
			type="button"
			class="btn btn-light btn-back mb-3"
		>
			<img width="6" class="mr-3" src="/images/vector-back-grey.png" />
			{{ $t('school.back-btn') }}
		</router-link>
		<Loader v-if="loader" />
		<div class="col-12" v-else>
			<div class="d-flex flex-wrap justify-content-between align-items-center mb-5">
				<h1 class="notification-title">
					<img src="/images/message-check.svg" alt="" />
					{{ data.title }}
				</h1>
				<p class="notification-date">
					{{data.date}}
				</p>
			</div>
      <div class="col-12 notification-card">
        <div class="notification_title_part">
          <div class="notification_title_part_img"></div>
          <div class="notification_text_part">
            <div class="notification_text_part_label">
              {{$t('notification_reject_2')}}
            </div>
            <div class="notification_text_part_text">
              {{$t('notification_reject_3')}}
            </div>
          </div>
        </div>
        <div class="notification_reasons">
          {{$t('notification_reject_4')}}
        </div>
        <div class="notification_reasons">
          {{$t('notification_reject_5')}}
        </div>
        <div class="notification_principle_justice">
          {{$t('notification_reject_6')}}
        </div>
        <div class="notification_desc">
          {{$t('notification_reject_7')}}
        </div>
        <div class="notification_desc">
          {{$t('notification_reject_8')}}
        </div>
        <div class="notification_desc">
          <strong>{{$t('notification_reject_9')}}</strong>
        </div>
        <div class="notification_desc">
          {{$t('notification_reject_10')}}
        </div>
        <div class="notification_desc">
          {{$t('notification_reject_11')}}
        </div>

        <div class="violations-list">
          <a
              v-if="Array.isArray(photoLinks)"
              v-for="(link, i) in photoLinks"
              :key="i"
              :href="link"
              target="_blank"
              class="photo-link btn-primary"
          >
            Фото
          </a>
        </div>

        <div class="notification_call_part">
          <div class="notification_call_part_img">

          </div>
          <div class="notification_call_part_text">
            {{$t('notification_call')}}
          </div>
        </div>
        <div class="notification_thanks">
          {{$t('notification_thanks')}}
        </div>
        <p class="notification-copyright">
          © 2020 {{$t('footer.elbasy-academy')}}. {{$t('footer.copyright')}}
        </p>
      </div>
		</div>
	</div>
</template>
<script>
	import ProfileNavbar from '@/components/ProfileNavbar'
	import Loader from '@/components/Loader'
  import { getPresignedUrl } from '@/utils/s3'

	export default {
		name: 'Settings',
		components: {
			ProfileNavbar,
			Loader
		},
		data() {
			return {
        API_ROOT: window.API_ROOT,
				data: {

				},
        photoLinks: [],
				loader: false
			}
		},
    filters :{
      round:function (value){
        return Math.round((value)*100)/100
      }
    },
		methods: {
      async getNotificationInfo(id) {
        try {
          const res = await this.$http.get(
              `${window.API_ROOT}/api/user/notifications/${id}`
          )
          if (res.body?.data) {
            this.data = res.body.data
            const rawLinks = this.data.data.cheater_links || []
            this.photoLinks = await Promise.all(
                rawLinks.map(link => getPresignedUrl(link))
            )
          }
        } catch (err) {
          console.error(err)
        } finally {
          this.loader = false
        }
      }
		},
		mounted() {
			this.getNotificationInfo(this.$route.params.id)
		}
	}
</script>

<style lang="scss" scoped>

.violations-list {
  margin-bottom: 50px;
  display: grid;
  grid-template-columns: repeat(14, 1fr);
  grid-gap: 20px;
}

.reject-message {
  margin-bottom: 30px;
  font-family: 'Roboto', sans-serif;
  color: #303030;
}

.notification_thanks {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #303030;
  margin-top: 30px;
}

.notification_call_part_text {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  color: #303030;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 30px;
}

.notification_call_part {
  background: #F7F8FC;
  border-radius: 10px;
  padding: 0 20px;
  display: flex;
}

.notification_call_part_img {
  width: 100px;
  height: 100px;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url("/images/notification_call_part_img.png");
}

.notification_regret {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  color: #2A8BF2;
  margin-bottom: 30px;
}

.notification_desc {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #303030;
  margin-bottom: 30px;
}

.notification_principle_justice {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #303030;
  padding-left: 30px;
  position: relative;
  margin-bottom: 30px;
}

.notification_principle_justice::before {
  position: absolute;
  content: "";
  top: 3px;
  left: 0;
  width: 17px;
  height: 17px;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url("/images/notification_principle_justice.svg");
}

.notification_reasons {
  background: #F7F8FC;
  border-radius: 10px;
  padding: 15px 25px;
  border-left: 5px solid #2A8BF2;
  margin-bottom: 15px;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #303030;
}

.notification_text_part_text {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #303030;
}

.notification_text_part_label {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: #303030;
  margin-bottom: 20px;
}


.notification_text_part {
  margin-left: 20px;
}

.notification_title_part {
  display: flex;
  margin-bottom: 30px;
}

.notification_title_part_img {
  width: 75px;
  height: auto;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url("/images/notification_new_type.png");
}

.notification {
  &-title {
    font-size: 24px;
    color: #05458c;
    font-weight: bold;

    img {
      display: inline-block;
      width: 33px;
      height: 33px;
      margin-right: 10px;
      object-fit: contain;
    }
  }

  &-download-wrapper {
    justify-content: center;
    display: flex;
  }

  &-download {
    min-width: 200px;
    margin: 1rem;
    cursor: pointer;
    text-align: center;
    background-color: #2A8BF2;
    height: 48px;
    padding-left: 10px;
    padding-right: 10px;
    line-height: 48px !important;
    text-decoration: none;
    color: white !important;
    border-radius: 10px;
    min-height: 48px;
    display: block;
    max-width: max-content;
  }

  &-date {
    font-size: 18px;
    color: #05458c;
  }

  &-card {
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid #dfe0eb;
    padding: 33px 26px;
  }

  &-logo {
    display: block;
    width: 147px;
    margin: 0 auto;
  }

  &-fullname {
    font-size: 30px;
    color: #05458C;
    text-align: center;
    margin: 32px 0;
    font-weight: bold;
  }

  &-results {
    color: #18A0FB;

    &__side {
      font-size: 14px;
      display: flex;
      flex-direction: column;
      align-items: center;

      span {
        font-size: 18px;
        font-weight: bold;
      }
    }

    &__overall {
      font-size: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;

      span {
        font-size: 30px;
        font-weight: bold;
      }
    }
  }

  &-callcenter {
    display: flex;
    flex-direction: column;
    align-items: center;

    a {
      display: flex;
      align-items: center;
      padding: 11px;
      border-radius: 10px;
      border: 1px solid #DFE0EB;
      margin-right: 10px;

      &::before {
        content: '';
        display: block;
        float: left;
        width: 22px;
        height: 31px;
        margin-right: 10px;
        background-image: url('/images/phone.svg');
        background-position: center;
        background-size: 90%;
        background-repeat: no-repeat;
      }
    }

    span {
      color: #05458C;
      opacity: 0.3;
    }
  }

  &-copyright {
    text-align: center;
    font-size: 14px;
    color: #05458C;
    opacity: 0.3;
  }
}

.violations-list .photo-link {
  background-color: #F00070 !important;
}

.violations-list .photo-link:hover {
  color: #FFF;
  background-color: #dc3545 !important;
}

@media screen and (max-width: 1700px) {
  .notification_title_part_img {
    width: 160px;
  }
}

@media screen and (max-width: 1600px) {
  .notification_title_part_img {
    width: 170px;
  }
}

@media screen and (max-width: 1500px) {
  .notification_title_part_img {
    width: 220px;
  }
}

@media screen and (max-width: 1300px) {
  .notification_title_part_img {
    width: 260px;
  }
}


@media screen and (max-width: 1000px) {
  .notification_call_part_img {
    display: none;
  }

  .notification_title_part_img {
    display: none;
  }

  .notification_call_part_text {
    padding: 20px;
  }

  .violations-list {
    grid-template-columns: repeat(2, 1fr);
    text-align: center;
  }
}

@media screen and (max-width: 700px) {

  .notification {
    &-title {
      font-size: 16px;

      img {
        display: none;
      }
    }

    &-date {
      font-size: 12px;
      margin-left: auto;
    }

    &-card {
      padding: 33px 13px;
    }

    &-results {
      &__side {
      display: none;
      }
    }

    &-message {
      margin: 15px 0;
    }

    &-callcenter {
      a {
        white-space: nowrap;
        font-size: 14px;
      }

      span {
        font-size: 12px;
      }
    }
  }
}
</style>
